import type { ViewportSyncGroup, ViewportSyncData } from '../types/chart'

/**
 * Creates a sync group for broadcasting the visible date range across charts.
 * Pass the same group instance to each EdgeChart's `viewportSync` prop.
 *
 * The publisher is a chart whose user is scrolling / zooming; peers in the
 * group call `setVisibleDateRange(from, to)` to align their viewport. Peers
 * with no bars in the broadcast window snap to the nearest bar — that thin
 * 1–2-bar state is the intentional "no data here" signal.
 */
export function createViewportSyncGroup(options: { anchored?: boolean } = {}): ViewportSyncGroup {
  const handlers = new Map<string, (data: ViewportSyncData) => void>()
  let publishing = false

  return {
    anchored: options.anchored === true,
    subscribe(id, handler) {
      handlers.set(id, handler)
    },
    unsubscribe(id) {
      handlers.delete(id)
    },
    publish(sourceId, data) {
      if (publishing) return
      publishing = true
      handlers.forEach((handler, id) => {
        if (id !== sourceId) handler(data)
      })
      publishing = false
    },
  }
}
